import { PackagePatternConfigDetail } from "@/features/operation-package-config-new/PackagePatternDetail";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/labor-core/config/$patternId/")({
  component: PatternDetailPage,
});

function PatternDetailPage() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.laborCore.operationPackages",
  });
  const { patternId } = useParams({
    from: "/_staff/labor-core/config/$patternId/",
  });

  return (
    <>
      <PackagePatternConfigDetail
        ownerProduct="HRF_LABOR_CORE"
        breadcrumbs={[
          {
            linkTo: "/labor-core/configs",
            label: t("laborCore"),
          },
        ]}
        patternId={patternId}
      />
    </>
  );
}
